
  import { Component } from 'vue-property-decorator'
  import { plainToInstance } from 'class-transformer'
  import BaseForm from '@/components/forms/view/BaseForm.vue'
  import { Form } from '@/entities/public/Resource/metadata'
  import {
    fixAmountFormatted,
    fixPrice,
    isValidNumber,
    parseToNumber,
    stringifySafe,
    toCamelCase,
    toSnakeCase,
  } from '@/utils/general'
  import { Enablement } from '@/entities/purchase'
  import LinkedPerson from '@/components/forms/fields/LinkedPerson.vue'
  import GFiles from '@/components/core/files/GFiles.vue'
  import GRadioButton from '@/components/core/input/GRadioButton.vue'
  import { DateGenerator } from '@/utils/date/DateGenerator'
  import { City } from '@/entities/public'
  import { Person } from '@/entities/persons'
  import dayjs from 'dayjs'
  import GCostField from '@/components/core/input/GCostField.vue'
  import AutoResume from '@/components/forms/AutoResume.vue'
  import { Stock } from '@/entities/sales'
  import { DocumentationView } from '@/components/forms/view/DocumentationView'
  import { PaymentOrder, PaymentOrderItem, PaymentSupportType } from '@/entities/finance'
  import { Expense, ProcessExpense } from '@/entities/settings'
  import GDatePicker from '@/components/core/input/GDatePicker.vue'
  import GAlert from '@/components/core/alert/GAlert.vue'
  import { Deal } from '@/entities/crm'

@Component({
  components: { GAlert, GDatePicker, GCostField, GRadioButton, GFiles, LinkedPerson, BaseForm, AutoResume },
  methods: { fixAmountFormatted, fixPrice, isValidNumber },
  computed: {},
})
  export default class InspectionEnablementTaskForm extends DocumentationView {
  componentKeys = ['circulationPermit', 'soap', 'technicalReview']
  enablement: Enablement = plainToInstance(Enablement, {})
  file = []
  payments = []
  stock: Stock = plainToInstance(Stock, {})
  components = []
  message = ''
  alert = {
    open: false,
    title: '',
    item: null,
  }

  circulationPermit = false
  soap = false
  technicalReview = false
  newInsurance = null
  newTechnicalReview = null
  paymentSupportType: PaymentSupportType[] = []
  processEnablementTaskId = null
  lastOrder = null
  missingValue = ''
  lastDocument = []
  processEnablementId = null
  enablementInspectionComponent = []
  enablementTaskInspectionComponent = []
  vehicleCleaningCost: 0
  idInspectionInspectedComponent = null
  auto = null
  path = null
  task = null
  amount = null
  showDetail = false
  total = null
  expiration = {
    circulationPermit: null,
    soap: null,
    technicalReview: null,
  }

  component = []
  cities: City[] = []
  plants: Person[] = []
  insurances: Person[] = []
  equipmentComponents = null
  errorMessage = {
    mileage: '',
  }

  errorIdentifierMessage = {
    status: {
      status: '',
      provisional: ''
      ,
    },
  }

  title = ''
  mileage = null
  panels = []
  section = {
    documents: false,
  }

  radioButtonMessage = {
    bodyWork: '',
    wheels: '',
    inside: '',
    mechanical: '',
    clean: '',
    answerDocuments: '',
  }

  formData = {
    soap: {
      photo: [],
      date: null,
      selection: null,
      cost: null,
      inspectionDate: null,
    },
    technicalReview: {
      photo: [],
      date: null,
      selection: null,
      cost: null,
      inspectionDate: null,
    },
    circulationPermit: {
      selection: null,
      date: null,
      photo: [],
      amount: null,
      cost: null,
      inspectionDate: null,
    },
    documentType: null,
    document: [],
    documentNumber: null,
  }

  fields = {
    circulationPermit: {
      properties: {
        accept: null,
        multiple: false,
        fileTypeId: null,
        name: '',
        label: '',
        required: false,
      },
    },
    technicalReview: {
      properties: {
        accept: null,
        multiple: false,
        fileTypeId: null,
        name: '',
        label: '',
        required: false,
      },
    },
    soap: {
      properties: {
        accept: null,
        multiple: false,
        fileTypeId: null,
        name: '',
        label: '',
        required: false,
      },
    },
    document: {
      properties: {
        accept: null,
        multiple: false,
        fileTypeId: null,
        name: '',
        label: '',
        required: false,
      },
    },
  }

  monthMapReverse = {
    '03': 'Mar',
    '08': 'Ago',
    '01': 'Ene',
    '02': 'Feb',
    '04': 'Abr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '09': 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dic',
  }

  monthMap = {
    Mar: '03',
    Ago: '08',
    Ene: '01',
    Feb: '02',
    Abr: '04',
    May: '05',
    Jun: '06',
    Jul: '07',
    Sep: 9,
    Oct: 10,
    Nov: 11,
    Dic: 12,
  }

  metadata = {}
  metadataCollection = {}

  async mounted () {
    this.loadingForm = true
    await this.setMetadata()
    const { uid, id, title, metadataCollection } = this
    const taskId = uid || id

    if (isValidNumber(taskId)) {
      await this.getEnablementTaskInfo(taskId)
    }

    if (!this.isBreadCrumbPresent(title)) {
      this.setFormCrumbs(metadataCollection, title, Boolean(taskId))
    }
    this.setTheBackup()
    this.displayDetail()
    this.loadingForm = false
  }

  setTheBackup () {
    const { backup } = this

    if (!backup) return

    const isEnablementExpense = 'enablementExpenseForm' in backup && backup?.enablementExpenseForm
    const isEnablementTaskForm = 'enablementTaskForm' in backup && backup?.enablementTaskForm

    const path = toCamelCase(backup.path)

    if (isEnablementTaskForm) {
      this.formData[path] = isEnablementTaskForm[path]
      this.formData.documentNumber = isEnablementTaskForm.documentNumber
      this.formData.document = isEnablementTaskForm.document
      this.lastOrder = this.lastOrder?.id ? this.lastOrder : isEnablementTaskForm.lastOrder
    }

    if (isEnablementExpense) {
      this.setExpense(isEnablementExpense)
    }
  }

  setExpense (expense) {
    let order = null
    if (!this.lastOrder) {
      order = plainToInstance(PaymentOrder, {
        items: [plainToInstance(PaymentOrderItem, {
          amount: parseToNumber(this.formData[toCamelCase(this.path)].cost),
          processExpense: plainToInstance(ProcessExpense, {
            expense: plainToInstance(Expense, {
              description: expense.expenseType.description,
              name: expense.expenseType.name,
            }),
          }),
        })],
      })

      order.items[0].recipients = [expense.recipient]
    } else {
      order = this.lastOrder
      order.items[0].recipients[0].payments.push(expense.recipient.payments[0])
    }

    this.lastOrder = order
  }

  async setMetadata () {
    this.loadingForm = true
    const { metadata } = this.getForm('EnablementTask', 'inspector_enablement_task')

    const { form } = metadata as Form
    this.title = form.title
    this.metadataCollection = metadata

    const processEnablement = await this.fetchData({
      query: { name: 'find', model: 'Process' },
      filter: { table_name: { _eq: 'enablement' } },
    })
    this.vehicleCleaningCost = processEnablement?.[0]?.config.vehicle_cleaning_cost
    this.processEnablementId = processEnablement?.[0]?.id
    const processEnablementTask = await this.fetchData({
      query: { name: 'find', model: 'Process' },
      filter: { table_name: { _eq: 'enablement_task' } },
    })

    this.processEnablementTaskId = processEnablementTask[0].id

    this.paymentSupportType = await this.fetchData({
      query: { name: 'find', model: 'PaymentSupportType' },
      filter: { name: { _eq: 'ticket' } },
    })
    this.formData.documentType = this.paymentSupportType[0]
    const fileInfo = await this.fetchData({
      query: { name: 'find', model: 'FileParameter' },
      filter: { process: { table_name: { _eq: 'inspection_inspected_component' } } },
    })

    this.plants = await this.fetchData({
      query: {
        name: 'find',
        model: 'Person',
        order: {
          alias: 'asc',
        },
      },
      filter: { company_type: { name: { _eq: `technical_review_plant` } } },
      limit: 100,
      force: true,
    })
    this.plants.push(plainToInstance(Person, { alias: 'Otra' }))
    const companyType = await this.fetchData({
      query: { name: 'find', model: 'CompanyType' },
      filter: { name: { _eq: 'insurance_carrier' } },
      force: true,
    })
    this.insurances = companyType?.[0]?.persons
    this.cities = await this.fetchData({
      query: { name: 'find', model: 'City' },
      filter: {},
      limit: 400,
    })
    this.setProperties(fileInfo, 'circulationPermit')
    this.setProperties(fileInfo, 'soap')
    this.setProperties(fileInfo, 'technicalReview')
    this.setProperties(fileInfo, 'document')
    const process = await this.fetchData({
      query: { name: 'find', model: 'Process' },
      filter: { table_name: { _eq: 'inspection_inspected_component' } },
    })
    this.idInspectionInspectedComponent = process?.[0]?.id
  }

  async getEnablementTaskInfo (id) {
    if (!id) return
    this.task = await this.fetchData({
      query: { name: 'fetch', model: 'EnablementTask', params: { id } },
    })

    this.circulationPermit = this.task.type.name === 'circulation_permit'
    this.soap = this.task.type.name === 'soap'
    this.technicalReview = this.task.type.name === 'technical_review'

    this.path = toSnakeCase(this.task.type.name)

    this.stock = await this.fetchData({
      query: { name: 'fetch', model: 'Stock', params: { id: this.task.enablement.stock.id } },
    })

    const idAuto = this?.stock?.viewDetails?.idAuto
    if (idAuto) {
      this.auto = await this.fetchData({
        query: { name: 'fetch', model: 'Auto', params: { id: idAuto } },
      })
    }
    this.enablementTaskInspectionComponent = await this.fetchData({
      query: { name: 'find', model: 'InspectionQualification' },
      filter: {
        component: {
          _and: [
            { id_process_record: { _eq: this.task.id } },
            { process: { table_name: { _eq: 'enablement_task' } } },
          ],
        },
      },
      force: true,
    })

    const idFile = this.enablementTaskInspectionComponent[0].component.id

    const process = (await this.fetchData({
      query: { name: 'find', model: 'Process' },
      filter: { table_name: { _eq: 'inspection_inspected_component' } },
    }))[0]

    this.file = await this.fetchData({
      query: { name: 'find', model: 'FileProcess' },
      filter: {
        _and: [
          { id_process_record: { _eq: idFile } },
          { parameter: { process: { id: { _eq: process.id } } } },
          { parameter: { file_type: { name: { _eq: 'photo' } } } },
        ],
      },
      force: true,
    })

    await this.findFormDataInfo()
    await this.findPaymentOrder(this.task)

    this.loadingForm = false
  }

  async setCirculationPermitData () {
    const { task, enablementTaskInspectionComponent, file } = this

  this.formData.circulationPermit.photo = file
  const city = this.getInspectionViewByOrder(enablementTaskInspectionComponent, 1)?.value
  this.formData.circulationPermit.selection = this.cities.find(c => c.name === city)
  const date = this.getInspectionViewByOrder(enablementTaskInspectionComponent, 2)?.value
  const month = date.split('/')[1]
  const updatedDate = !isValidNumber(month) ? date : date.replace(`/${month}/`, `/${this.monthMapReverse[month]}/`)
  this.formData.circulationPermit.date = this.generateDates.find(date => date.internal === updatedDate)
  this.formData.circulationPermit.cost = task.cost
  }

  async setSoapData () {
    const { enablementTaskInspectionComponent, file } = this

    this.formData.soap.photo = file
    const insurance = this.getInspectionViewByOrder(enablementTaskInspectionComponent, 1)?.value
    this.formData.soap.selection = this.insurances.find(insuranceItem => insuranceItem.alias === insurance)
    const date = this.getInspectionViewByOrder(enablementTaskInspectionComponent, 2)?.value
    const month = date.split('/')[1]
    const updatedDate = !isValidNumber(month) ? date : date.replace(`/${month}/`, `/${this.monthMapReverse[month]}/`)
    this.formData.soap.date = this.generateDates.find(date => date.internal === updatedDate)
    this.formData.soap.cost = this.task.cost
  }

  async setTechnicalReviewData () {
    const { task, enablementTaskInspectionComponent, file } = this

    this.formData.technicalReview.photo = file
    const plant = this.getInspectionViewByOrder(enablementTaskInspectionComponent, 1)?.value
    this.formData.technicalReview.selection = this.plants.find(plantItem => plantItem.alias === plant)
    const date = this.getInspectionViewByOrder(enablementTaskInspectionComponent, 2)?.value
    const month = date.split('/')[1]
    const updatedDate = !isValidNumber(month) ? date : date.replace(`/${month}/`, `/${this.monthMapReverse[month]}/`)
    this.formData.technicalReview.date = this.technicalDates.find(date => date.internal === updatedDate)
    this.formData.technicalReview.cost = task.cost
  }

  async findFormDataInfo () {
    const { circulationPermit, soap, technicalReview } = this

    if (circulationPermit) {
      await this.setCirculationPermitData()
    } else if (soap) {
      await this.setSoapData()
    } else if (technicalReview) {
      await this.setTechnicalReviewData()
    } else {
      console.log('aja else')
    }
  }

  async findPaymentOrder (task) {
    let paymentOrder = (await this.fetchData({
      query: { name: 'find', model: 'PaymentOrder' },
      filter: {
        _and: [
          { id_process_record: { _eq: task.id } },
          { process: { table_name: { _eq: 'enablement_task' } } },
        ],
      },
      force: true,
    }))[0]

    paymentOrder = await this.fetchData({
      query: { name: 'fetchInspector', model: 'PaymentOrder', params: { id: paymentOrder.id } },
      force: true,
    })

    this.lastOrder = paymentOrder
    this.formData.documentNumber = paymentOrder?.supportNumber
    const stock = (await this.fetchData({
      query: { name: 'find', model: 'Stock' },
      filter: { id_enablement: { _eq: task.enablement.id } },
    }))[0]

    await Promise.all(
      paymentOrder.payments.map(async payment => {
        const paymentData = await this.fetchData({
          query: { name: 'fetchInspector', model: 'Payment', params: { id: payment.id } },
          force: true,
        })
        paymentData.deal = plainToInstance(Deal, {})
        paymentData.deal.auto = stock.auto
        this.payments.push(paymentData)
      }),
    )

    const process = await this.fetchData({
      query: { name: 'find', model: 'Process' },
      filter: { table_name: { _eq: 'payment_order' } },
    })

    this.formData.document = await this.fetchData({
      query: { name: 'find', model: 'FileProcess' },
      filter: {
        _and: [
          { id_process_record: { _eq: paymentOrder.id } },
          { parameter: { process: { id: { _eq: process.id } } } },
          { parameter: { name: { _eq: 'support' } } },
        ],
      },
      force: true,
    })
  }

  async setFilesData () {
    const { circulationPermit, soap, technicalReview, task } = this

    const fileInfo = await this.fetchData({
      query: { name: 'find', model: 'FileParameter' },
      filter: { process: { table_name: { _eq: 'inspection_inspected_component' } } },
    })

    this.setProperties(fileInfo, 'circulationPermit')
    this.setProperties(fileInfo, 'soap')
    this.setProperties(fileInfo, 'technicalReview')
    this.setProperties(fileInfo, 'document')

    const process = await this.fetchData({
      query: { name: 'find', model: 'Process' },
      filter: { table_name: { _eq: 'inspection_inspected_component' } },
    })
    this.idInspectionInspectedComponent = process?.[0]?.id

    if (!task?.id) { // || task?.closingReason?.id
      await this.getLastFileEnablement(process)
      return
    }
    if (circulationPermit?.[0]?.idInspectedComponent) {
      await this.setPhotoToForm(circulationPermit[0].idInspectedComponent, 'circulationPermit', process?.[0]?.id)
    }
    if (soap?.[0]?.idInspectedComponent) {
      await this.setPhotoToForm(soap[0].idInspectedComponent, 'soap', process?.[0]?.id)
    }
    if (technicalReview?.[0]?.idInspectedComponent) {
      await this.setPhotoToForm(technicalReview[0].idInspectedComponent, 'technicalReview', process?.[0]?.id)
    }
  }

  async getLastFileEnablement (process) {
    if (!toCamelCase(this.path)) return

    const idProcessRecord = this[toCamelCase(this.path)]?.[0]?.idInspectedComponent

    if (!idProcessRecord) return

    this.lastDocument = await this.fetchData({
      query: { name: 'find', model: 'FileProcess' },
      filter: {
        _and: [
          { id_process_record: { _eq: idProcessRecord } },
          { parameter: { process: { id: { _eq: process?.[0]?.id } } } },
          { parameter: { name: { _eq: 'photo_inspection' } } },
        ],
      },
      force: true,
    })
  }

  async setPhotoToForm (idProcessRecord, fieldKey, idProcess) {
    if (!idProcessRecord) return

    this.formData[fieldKey].photo = await this.fetchData({
      query: { name: 'find', model: 'FileProcess' },
      filter: {
        _and: [
          { id_process_record: { _eq: idProcessRecord } },
          { parameter: { process: { id: { _eq: idProcess } } } },
          { parameter: { file_type: { name: { _eq: 'photo' } } } },
        ],
      },
      force: true,
    })

    const { getInspectionViewByOrder } = this

    const date = getInspectionViewByOrder(this[fieldKey], 2)?.value

    this.formData[fieldKey].date = DateGenerator.findGeneratedDate(date).internal
    this.formData[fieldKey].inspectionDate = DateGenerator.findGeneratedDate(date).internal
    if (fieldKey === 'circulationPermit') {
      const answer = getInspectionViewByOrder(this[fieldKey], 1)?.value
      if (answer) {
        this.formData[fieldKey].selection = { name: answer }
      }

      this.formData[fieldKey].amount = getInspectionViewByOrder(this[fieldKey], 3)?.value
    }

    if (fieldKey === 'soap') {
      const answer = getInspectionViewByOrder(this[fieldKey], 1)?.value

      if (answer) {
        this.formData[fieldKey].selection = { alias: answer }
      }
    }

    if (fieldKey === 'technicalReview') {
      const answer = getInspectionViewByOrder(this[fieldKey], 1)?.value
      if (answer) {
        const plant = this.plants.find(p => p.name === answer || p.alias === answer)
        this.formData[fieldKey].selection = { alias: plant?.alias }
      }
    }

    this.formData[fieldKey].cost = getInspectionViewByOrder(this[fieldKey], 1)?.component.cost
  }

  setPropertiesBySlug (fileInfo, fileTypeName, fieldKey) {
    if (!fileInfo?.length) return
    const info = fileInfo.find(fileParameter => fileParameter.name === fileTypeName)
    if (info) {
      this.fields[fieldKey].properties.accept = info.fileType.mimes
      this.fields[fieldKey].properties.multiple = info.multiple
      this.fields[fieldKey].properties.fileTypeId = info.fileType.id
      this.fields[fieldKey].properties.name = info.name
      this.fields[fieldKey].properties.label = info.description
      this.fields[fieldKey].properties.required = info.required
      this.fields[fieldKey].properties.icon = info.fileType.icon
    }
  }

  setProperties (fileInfo, fieldKey) {
    if (!fileInfo?.length) return
    const info = fileInfo[0]
    if (info) {
      this.fields[fieldKey].properties.accept = info.fileType.mimes
      this.fields[fieldKey].properties.multiple = info.multiple
      this.fields[fieldKey].properties.fileTypeId = info.fileType.id
      this.fields[fieldKey].properties.name = info.name
      this.fields[fieldKey].properties.label = info.description
      this.fields[fieldKey].properties.required = info.required
      this.fields[fieldKey].properties.icon = info.fileType.icon
    }
  }

  displayDetail () {
    const { enablement, metadataCollection } = this

    this.metadata = {
      data: enablement,
      metadata: metadataCollection,
    }

    this.showDetail = Boolean(enablement.id)
  }

  get calculatedExpenses () {
    const { lastOrder } = this

    if (lastOrder?.payments?.length) {
      this.missingValue = ''
    }

    return lastOrder?.payments
  }

  async send () {
    const { expenseError, calculatedExpenses } = this
    if (!this.$refs.form.validate() || expenseError.length || !calculatedExpenses?.length) {
      if (!calculatedExpenses?.length) this.missingValue = 'Debe registrar el gasto'
      this.$refs.form.validate()
      await this.setFieldError()
      return
    }

    this.loadingForm = true

    if (!this.task?.id) {
      await this.handleDocument(this)
    } else {
      await this.updateEnablementTask(this)
    }
    this.loadingForm = false
    await this.close()
  }

  get change () {
    const { formData, panels, loadingForm } = this

    return stringifySafe([formData, panels, loadingForm])
  }

  get taskStatusIsDisabled () {
    const { task } = this

    return task?.status?.isClosed || task?.status?.isToConfirm
  }

  get mileageComponent () {
    const { enablement: { inspectionIdentifiers }, enablementInspectionComponent } = this
    if (enablementInspectionComponent?.length) {
      const components = enablementInspectionComponent?.filter(ic => ic.component?.inspectionComponent?.component?.slug === 'mileage')

      if (components.length) {
        return components
      }
    }

    return inspectionIdentifiers?.filter(ic => ic.component?.inspectionComponent?.component?.slug === 'mileage')
  }

  get totalExpenses () {
    const { formData, calculatedExpenses, path } = this

    const cost = formData[toCamelCase(path)].cost

    if (!calculatedExpenses?.length || !cost) return 0

    return calculatedExpenses.reduce((acc, payment) => acc + parseToNumber(payment?.amount), 0)
  }

  get isOverPrice () {
    const { formData, totalExpenses, path } = this

    if (!totalExpenses) return false

    const cost = formData[toCamelCase(path)].cost
    return parseToNumber(totalExpenses) > parseToNumber(cost)
  }

  get isExpenseFull () {
    const { formData, totalExpenses, path } = this

    if (!totalExpenses) return false
    const cost = formData[toCamelCase(path)].cost
    return parseToNumber(totalExpenses) < parseToNumber(cost)
  }

  get expenseError () {
    const { formData, path, isOverPrice, lastOrder, totalExpenses, isExpenseFull, missingValue } = this

    if (missingValue?.length) return missingValue

    if (isOverPrice) return 'El gasto no puede ser mayor al monto del documento'

    if (!lastOrder?.payments?.length) return ''
    const cost = formData[toCamelCase(path)].cost
    return !isExpenseFull ? '' : `Se debe cubrir el monto del documento ${fixPrice(parseToNumber(cost) - parseToNumber(totalExpenses))}`
  }

  get sendCirculation () {
    const { path } = this

    return path === 'circulation_permit'
  }

  get sendSoap () {
    const { path } = this

    return path === 'soap'
  }

  get sendTechnicalReview () {
    const { path } = this

    return path === 'technical_review'
  }

  get isFilledCirculation () {
    const { formData: { circulationPermit: { date, selection, cost, photo } } } = this

    return Boolean(date) && Boolean(selection?.id) && Boolean(parseInt(cost)) && Boolean(photo?.length)
  }

  get isFilledSoap () {
    const { formData: { soap: { date, selection, cost, photo } }, newInsurance } = this
    const isSelection = selection?.id ? true : selection?.alias === 'Otra' && newInsurance
    return Boolean(date && isSelection && parseInt(cost) && photo?.length)
  }

  get isFilledTechnicalReview () {
    const { formData: { technicalReview: { date, selection, cost, photo } } } = this

    return Boolean(date && selection && parseInt(cost) && photo?.length)
  }

  get isFilledSome () {
    const { isFilledSoap, isFilledCirculation, isFilledTechnicalReview } = this

    return isFilledCirculation || isFilledSoap || isFilledTechnicalReview
  }

  async searchCity (val) {
    if (!val) {
      this.cities = await this.fetchData({
      query: { name: 'find', model: 'City' },
      filter: {},
      limit: 400,
      })
      return
    }
    this.cities = await this.fetchData({
      query: { name: 'find', model: 'City' },
      filter: { name: { _ilike: `%${val}%` } },
      limit: 100,
    })
  }

  async searchCompany (val) {
    if (!val) {
      this.insurances = await this.fetchData({
      query: { name: 'find', model: 'Person', order: { alias: 'asc' } },
      filter: { company_type: { name: { _eq: `insurance_carrier` } } },
      force: true,
    })
      return
    }

    this.insurances = await this.fetchData({
      query: { name: 'find', model: 'Person', order: { alias: 'asc' } },
      filter: { company_type: { name: { _eq: `insurance_carrier` } }, alias: { _ilike: `%${val}%` } },
      force: true,
    })
  }

  async searchPlants (val) {
    if (!val) {
      this.plants = await this.fetchData({
        query: {
          name: 'find',
          model: 'Person',
          order: {
            alias: 'asc',
          },
        },
        filter: { _and: [{ company_type: { name: { _eq: `technical_review_plant` } } }] },
        limit: 100,
      })
      return
    }

    this.plants = await this.fetchData({
      query: {
        name: 'find',
        model: 'Person',
        order: {
          alias: 'asc',
        },
      },
      filter: { _and: [{ company_type: { name: { _eq: `technical_review_plant` } } }, { alias: { _ilike: `%${val}%` } }] },
      limit: 100,
    })
    this.plants.push(plainToInstance(Person, { alias: 'Otra' }))
  }

  get ppu () {
    const { auto } = this

    return auto?.ppu?.split('')[auto?.ppu.length - 1]
  }

  get autoYear () {
    const { auto } = this

    return auto?.year
  }

  get technicalDates () {
    const { ppu, autoYear } = this

    if (!ppu) return []
    const currentYear = dayjs().year()
    const currentMonth = dayjs().month() + 1

    let dates = DateGenerator.calculateMonthByDigit(parseToNumber(ppu), parseToNumber(autoYear))
    const monthMap = {
      Mar: '03',
      Ago: '08',
      Ene: '01',
      Feb: '02',
      Abr: '04',
      May: '05',
      Jun: '06',
      Jul: '07',
      Sep: '09',
      Oct: '10',
      Nov: '11',
      Dic: '12',
    }
    dates = dates.filter(date => {
      const year = parseInt(date.internal.match(/\d{4}/)[0])
      let fixDate = date.internal
      for (const [key, value] of Object.entries(monthMap)) {
        fixDate = fixDate?.replace(key, value)
      }

      const monthGenerate = dayjs(fixDate, 'DD/MM/YYYY').month() + 1

      if (year > currentYear) {
        return true
      }

      if (year === currentYear) {
        return monthGenerate >= currentMonth
      }

      return false
    })

    return dates
  }

  get generateDates () {
    const currentYear = dayjs().year()
    const dates = DateGenerator.generateDates(currentYear, true)
    return this.filterDates(dates)
  }

  filterDates (dates) {
    const currentYear = dayjs().year()
    const currentMonth = dayjs().month() + 1 // Mes indexado (0 = Enero)
    const monthMap = {
      Mar: '03',
      Ago: '08',
      Ene: '01',
      Feb: '02',
      Abr: '04',
      May: '05',
      Jun: '06',
      Jul: '07',
      Sep: '09',
      Oct: '10',
      Nov: '11',
      Dic: '12',
    }
    return dates.filter(date => {
      const year = parseInt(date.internal.match(/\d{4}/)[0])
      let replacedDate = date.internal
      for (const key in monthMap) {
        if (replacedDate.includes(key)) {
          replacedDate = replacedDate.replace(key, monthMap[key])
          break
        }
      }
      const monthGenerate = dayjs(replacedDate, 'DD/MM/YYYY').month() + 1

      if (monthGenerate === currentMonth) {
        return year > currentYear
      }
      if (monthGenerate > currentMonth) {
        return year >= currentYear
      }

      if (currentMonth > monthGenerate) {
        return year > currentYear
      }
      return false
    })
  }

  get generateSoapDates () {
    const currentYear = dayjs().year()
    const dates = DateGenerator.generateDates(currentYear, true, false)

    return this.filterDates(dates)
  }

  saveBackup () {
    const { backup, formData, path, lastOrder } = this

    if (backup) {
      backup.enablementTaskForm = { ...formData, path, lastOrder }
      if (backup?.enablementExpenseForm) {
        backup.enablementExpenseForm = null
      }
      this.setBackup(backup)
    } else {
      this.setBackup({ enablementTaskForm: { ...formData, path, lastOrder } })
    }
  }

  async createInsurance () {
    const { newInsurance } = this

    if (!newInsurance) return

    const personType = (await this.fetchData({
      query: { name: 'find', model: 'CompanyType' },
      filter: { name: { _eq: 'insurance_carrier' } },
    }))[0]

    this.formData.soap.selection = await this.pushData({
      model: 'Person',
      fields: {
        alias: newInsurance.toUpperCase(),
        id_company_type: personType.id,
        name_person_type: 'company',
      },
    })
  }

  async createTechnicalReview () {
    const { newTechnicalReview } = this

    if (!newTechnicalReview) return

    const personType = (await this.fetchData({
      query: { name: 'find', model: 'CompanyType' },
      filter: { name: { _eq: 'technical_review_plant' } },
    }))[0]

    this.formData.technicalReview.selection = await this.pushData({
      model: 'Person',
      fields: {
        alias: newTechnicalReview.toUpperCase(),
        id_company_type: personType.id,
        name_person_type: 'company',
      },
    })
  }

  async createExpenseEnablementTask () {
    await this.createInsurance()
    await this.createTechnicalReview()
    await this.updateEnablementTask(this, false)
    this.saveBackup()
    await this.$router.push({
      name: 'generic-enablement-expense',
      params: {
        model: 'EnablementTask',
        uid: 'create',
      },
    }).catch(() => { })
  }

  async updateAmount (cost) {
    await this.pushData({
        model: 'PaymentOrder',
        fields: {
          id: this.lastOrder.id,
          amount: cost,
        },
    })

    await this.pushData({
      model: 'EnablementTask',
      fields: {
        id: this.task.id,
        cost,
      },
    })

    const inspectionQualification = await this.fetchData({
      query: { name: 'find', model: 'InspectionQualification' },
      filter: {
        component: {
          _and: [
            { id_process_record: { _eq: this.task.id } },
            { process: { table_name: { _eq: 'enablement_task' } } },
            {
              _or: [
                { inspection_component: { component: { category: { name: { _in: ['Documentación'] } } } } },
              ],
            },
          ],
        },
      },
      force: true,
      })

      const inspectionInspectedComponent = inspectionQualification[0].component

      await this.pushData({
        model: 'InspectionInspectedComponent',
        fields: {
          id: inspectionInspectedComponent.id,
          cost,
        },
      })
  }

  async editExpense (item) {
    await this.createInsurance()
    await this.createTechnicalReview()
    await this.updateEnablementTask(this, false)
    let cost = null
    if (this.formData[toCamelCase(this.path)].cost) {
      cost = this.formData[toCamelCase(this.path)].cost
    }

    if (isValidNumber(cost) && parseToNumber(cost) !== parseToNumber(this.lastOrder.amount)) {
      await this.updateAmount(parseToNumber(cost))
    }

    this.saveBackup()
    await this.$router.push({
      name: 'generic-enablement-expense',
      params: {
        model: 'EnablementTask',
        uid: item.id.toString(),
      },
    }).catch(() => { })
  }

  enablePayment (item) {
    return item.id && item.status && (item.status.name !== 'closed' && item.status.name !== 'pending_payment')
  }

  confirmRemoveExpense (item) {
    this.alert = {
      open: true,
      title: '¿Está seguro que desea eliminar el gasto?',
      item,
    }
  }

  async removeExpense (item) {
    for (let i = 0; i < this.lastOrder?.items.length; i++) {
      const recipient = this.lastOrder.items[i].recipients[0]
      const itemType = this.lastOrder.items[i]
      const posPayment = recipient?.payments?.findIndex(_ => this.findLocalPayment(_, recipient.person, itemType, item))

      if (posPayment !== -1 && this.lastOrder.items[i].recipients?.length) {
          this.lastOrder.items[i].recipients[0]?.payments.splice(posPayment, 1)
      }
      this.alert.open = false
    }
  }

  findLocalPayment (payment, person, type, val) {
    return !payment.id && type?.name === val?.type &&
      ((val?.account?.id && payment?.recipientAccount?.id === val?.account?.id) ||
        (val?.paymentType?.id && payment?.type?.id === val?.paymentType?.id) ||
        (val?.paymentRecipient?.person?.id === person.id && val?.amount === payment?.amount))
  }
  }
